
import {Component, Prop, Vue} from 'vue-property-decorator';
import stores from '@/stores';
import {SweetModal} from 'sweet-modal-vue';
import GlobalFunctions from '@/GlobalFunctions';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import vPagination from '@/components/VuePlainPagination.vue';
import _ from 'lodash';
import router from '@/router';

@Component({
  components: {
    SweetModal,
    NevronSearch,
    NevronSearchNoResults,
    vPagination,
  },
})
export default class AttachLibrary extends Vue {

  accommodation: any = '';
  library: any = [];
  firstNameRules = {};
  lastNameRules = {};
  companyRules = {};
  response: any = null;
  perpage = 20;
  selectedLibrary: number[] = [];
  ids: number[] = [];

  search: any = {
    query: '',
    current: '',
  };
  globalFunctions = new GlobalFunctions();
  searchItems = _.debounce(() => {
    this.fetchData(1, this.search.query, this.perpage);
  }, 400);
  openCreatePopup() {
    // @ts-ignore
    this.$children[0].close();
    this.$emit('create');
  }
  mounted() {

    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }

    this.fetchData(index, this.search.current, this.perpage);
  }
  fetchData(index: number | null, search: string | null, perpage: number | 10): any {
    stores.Library.fetchData(index, search, perpage)
      .then((response: any) => {
        console.log('response', response);
        this.response = response;
        this.library = this.response.data;
        this.search.current = this.search.query;
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }
  Next() {
    stores.Assets.attachAccomodation(this.selectedLibrary, this.$route.params.id)
      .then((resp: any) => {
        // @ts-ignore
        this.$children[0].close();
        this.$emit('save');
        // this.$router.push(`stays/${response.id}`);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
}
